import React from 'react'
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, 
    Card,
    CardBody} from 'reactstrap';

export default class MobileMenu extends React.Component {
    state = {
        isOpen: false,
        openPopular: false
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
            openPopular: this.state.isOpen ? this.state.openPopular : false
        })
    }

    locationList = list => {
        return  list.map((l, idx) => 
            <div key={l.key} className={'mb-2'}>
                <a href={l.href}>{l.name}</a>
                <div className='pull-right d-inline-block' style={{fontSize: '1.5rem', lineHeight: 1}}>&rsaquo;</div>
            </div>
        )
    }

    render() {
        const { logo, links} = this.props
        const { isOpen, openPopular} = this.state
        return (
            <div>
                <Navbar light expand="md">
                    <NavbarBrand href={logo.href} style={{maxWidth: '60%'}}><img src={logo.src} alt={logo.alt} className='img-fluid'/></NavbarBrand>
                    <NavbarToggler onClick={this.toggle} className="ml-3"/>
                    <Collapse isOpen={isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <NavLink href="#" className="text-primary"
                                     onClick={(e) => { e.preventDefault();this.setState({ openPopular: !openPopular }) }}>
                                    {this.props.toggle_text}
                                </NavLink>
                                <Collapse isOpen={openPopular} style={{position: 'absolute', zIndex: 999, width: "100%"}} className="mb-3 mt-2">
                                    <Card>
                                        <CardBody className="text-left">
                                            <h6 className='ml-5 mb-3'>{this.props.top_cities_text}</h6>
                                            {this.locationList(this.props.cities)}
                                            <h6 className='ml-5 my-3'>{this.props.top_airports_text}</h6>
                                            {this.locationList(this.props.airports)}
                                        </CardBody>
                                    </Card>
                                </Collapse>
                            </NavItem>
                            {links.map((link, index) =>
                                <NavItem key={index}>
                                    <NavLink href={link.href} className="text-primary">
                                        {link.icon && <i className={link.icon} />}
                                        {link.text}
                                    </NavLink>
                                </NavItem>
                            )}
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}